module.exports = __webpack_public_path__ + "static/media/IsProgrami_BolumNo.9b19c573.png";